module.exports = __webpack_public_path__ + "static/media/location-window.f0652977.png";